import { translateEnum } from 'aos-helpers/src/helpers/translations/Translations'
import { EnumValues } from 'enum-values'
import { TFunction } from 'i18next'
export enum TaskFilter {
    Todo = 'todo',
    AssignedToMe = 'my',
    Overdue = 'overdue',
    InProgress = 'in-progress',
    OnHold = 'on-hold',
    Done = 'done',
    Cancelled = 'cancelled',
    All = 'all',
}

export const allTaskFilters: TaskFilter[] = EnumValues.getValues<TaskFilter>(TaskFilter)

export const translateTaskFilter = (t: TFunction) =>
    translateEnum<TaskFilter>(t)(TaskFilter, 'task-filter')
